import styled from 'styled-components'

import Card from '~/components/card'
import Remove from '~/components/remove'
import { device } from '~/styles/utils'

import { Profile } from './components-v2'

export const StyledCard = styled(Card)`
  &.amp-card.with-border {
    border: 1px solid ${({ theme }) => theme.color.border.default};
    margin-top: 24px;
    padding: 32px 16px;
    height: 100%;

    @media ${device('notMobile')} {
      padding: 24px;
    }

    &:last-of-type {
      margin-bottom: 24px;
    }

    header {
      margin-top: 0px;
    }

    li {
      margin-bottom: 0px;

      > div:nth-child(3) {
        border-top: 1px solid ${({ theme }) => theme.color.border.default};
        padding: 16px 0;
        margin-top: 16px;
      }
    }
  }
`

export const RemoveButton = styled(Remove)`
  && {
    .amp-button.remove.icon {
      padding-bottom: 10px;
      line-height: 16px;
      font-size: 16px;
      color: ${({ theme }) => theme.color.text.link.default} !important;
    }
  }
`

export const OrderItem = styled.li`
  overflow: none;
  list-style: none;
  margin-bottom: 0;

  @media ${device('notMobile')} {
    margin-bottom: 60px;
  }
`

export const ProfileV2 = styled(Profile)`
  display: flex;
  padding: 0;
  padding-top: 20px;
  i {
    font-size: 40px;
    margin: 0;
    margin-right: 10px;
  }
  span {
    font-size: 14px;
  }
`

export const Header = styled.header`
  border: none;

  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 60px;

  @media ${device('notMobile')} {
    margin-top: 40px;
  }
`
